import { render, staticRenderFns } from "./AppRelation.vue?vue&type=template&id=2300975f&scoped=true&"
import script from "./AppRelation.vue?vue&type=script&lang=js&"
export * from "./AppRelation.vue?vue&type=script&lang=js&"
import style0 from "./AppRelation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AppRelation.vue?vue&type=style&index=1&id=2300975f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2300975f",
  null
  
)

export default component.exports